import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

const initializeSentry = () => {
  Sentry.init({
    dsn: 'https://3ad88f33d9394f2fbf6906d45faff8ff@o36975.ingest.sentry.io/5860925',
    environment: process.env.NODE_ENV,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.1
  });
};

const logError = (error, extra = {}) => {
  Sentry.captureException(error, {
    extra
  });
};

const logApiError = (method, errorCode, errorMessage, fullURL, ...params) => {
  if (errorCode < 400 || errorCode >= 500) {
    Sentry.captureException(new Error(`API Exception ${method} ${fullURL}: ${errorCode} -- ${errorMessage}`), { ...params });
  } else {
    Sentry.captureMessage(`API non-fatal Exception ${method} ${fullURL}: ${errorCode} -- ${errorMessage}`, { ...params });
  }
};

const logMessage = (message, extra) => Sentry.captureMessage(message, { extra });

export {
  initializeSentry,
  logError,
  logApiError,
  logMessage
};
